<div class="login-container">
  <sh-splash-screen 
    id="loginSplashScreen" 
    label="Search Assistant"
    [attr.image]="'url(/assets/img/login-background.jpg)'">
    <sh-button id="loginBtn" label="Login" #loginButton></sh-button>
    <sh-spinner *ngIf="loaderFlag" overlay label='Loading...'></sh-spinner>
  </sh-splash-screen>
</div>
